import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLoyaltyRedemption } from '../../services/api';

export const fetchLoyaltyRedemption = createAsyncThunk(
    'loyaltyRedemption/fetchRedemption',
    async ({ perPage, page }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyRedemption(perPage, page);
            const data = response.data;
            return {
                items: data.data || data,
                totalPages: data.last_page,
            };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

const loyaltyRedemptionSlice = createSlice({
    name: 'loyaltyRedemption',
    initialState: {
        items: [],
        loading: true,
        error: '',
        totalPages: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLoyaltyRedemption.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(fetchLoyaltyRedemption.fulfilled, (state, action) => {
                state.items = action.payload.items;
                state.totalPages = action.payload.totalPages;
                state.loading = false;
            })
            .addCase(fetchLoyaltyRedemption.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            })
    },
});

export default loyaltyRedemptionSlice.reducer;
